// extracted by mini-css-extract-plugin
module.exports = {"notification":"fJWIF","notificationText":"zfLXD","subscribed":"UdJUn","hideNotification":"Y0MmQ"};